export const getFormattedCityStateZip = (city, state, zip) => {
  let cityStateZip = '';
  if (city) {
    cityStateZip = city;
  } else {
    cityStateZip = '';
  }
  if (state && state !== '') {
    cityStateZip = cityStateZip +
      (cityStateZip && cityStateZip !== '' ? ', ' : '') +
      state;
  }
  if (zip && zip !== '') {
    cityStateZip = cityStateZip +
      (cityStateZip && cityStateZip !== '' ? ' ' : '') +
      zip;
  }

  return cityStateZip;
};
